import React from 'react';
import { observer } from 'mobx-react';
import { updatePaidUserWelcomePopupShown } from 'Utils/commonApi';
import userDetail from 'Stores/userDetail';
import HandshakeImg from 'Assets/png/handshake.png';
import Button from './Button';

const PaidUserWelcomePopup = observer(props => {
  const [showPopup, setShowPopup] = React.useState(false);

  const { memberSubscription } = userDetail.userInfo;
  const { lbpaidPlanWelcomePopupShown = null, id = null } =
    memberSubscription || {};

  React.useEffect(() => {
    if (
      lbpaidPlanWelcomePopupShown !== null &&
      lbpaidPlanWelcomePopupShown === false &&
      id !== null
    ) {
      setShowPopup(true);
      updatePaidUserWelcomePopupShown(id);
    }
  }, []);

  const handleClick = () => {
    setShowPopup(false);
  };

  return showPopup ? (
    <>
      <div className="paid-user-welcome-popup common-popup">
        <div className="popup-wrap">
          <img src={HandshakeImg} alt="handshake" />
          <div className="title">Welcome to Adapt</div>
          <div className="description">
            We are thrilled that you have chosen us!
            <br /> We are delighted to have you as part of our growing family
            with over 300K happy users!
          </div>
          <Button
            btnText="Done"
            icon={false}
            iconName=""
            type="button"
            className="action-btn"
            click={e => handleClick()}
          />
        </div>
      </div>
      <div className="common-popup-mask" />
    </>
  ) : (
    ''
  );
});

export { PaidUserWelcomePopup };
export default PaidUserWelcomePopup;
